import { render, staticRenderFns } from "./RFinancieross.vue?vue&type=template&id=5863a44a&scoped=true&"
import script from "./RFinancieross.vue?vue&type=script&lang=js&"
export * from "./RFinancieross.vue?vue&type=script&lang=js&"
import style0 from "./RFinancieross.vue?vue&type=style&index=0&id=5863a44a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863a44a",
  null
  
)

export default component.exports